// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.myTool {\n  border: 1px solid #ebeef5 !important;\n  color: #606266;\n  line-height: 1.4;\n  text-align: justify;\n  font-size: 14px;\n  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);\n  word-break: break-all;\n  width: 320px;\n}\n", ""]);
// Exports
module.exports = exports;
